import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';
import { RewardPointRequest } from '../api/rewardpoint/rewardpointrequest';
import { RewardPointResponse, RewardPointResponseDtoImpl } from '../api/rewardpoint/rewardpointresponse';
import { RewardPointBuilder } from '../dto/rewardpoint/rewardpointbuilder';

export class RewardPointAPIProcessorImpl extends SixdeeCRBTAPIProcessor<RewardPointRequest, RewardPointResponse>
{
    private LOGGER: Logger = LogManager.getLogger(RewardPointAPIProcessorImpl.name);
    execute(request: RewardPointRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let responseData = responseMapper.getResponseMap();
                if(responseData && responseData.respCode === 0)
                {
                    let response = new RewardPointResponseDtoImpl(APIFeatures.GET_REWARD_POINT, "Get Reward Point Success");

                    response.setRewardPointDto(new RewardPointBuilder(responseData).buildAll());
    
                    this.getAPISuccess(response);
                }
                else
                {
                    let message = "FAILED";
                    if(responseMapper && responseMapper.getStatusMsg() !== null && responseMapper.getStatusMsg() !== undefined)
                    {
                        message = responseMapper.getStatusMsg();
                    }
                    this.getAPIFailure(new RewardPointResponseDtoImpl(APIFeatures.GET_REWARD_POINT, message));
                }    
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new RewardPointResponseDtoImpl(APIFeatures.GET_REWARD_POINT, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new RewardPointResponseDtoImpl(APIFeatures.GET_REWARD_POINT, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new RewardPointResponseDtoImpl(APIFeatures.GET_REWARD_POINT, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        let message = "FAILED";
        if(responseMapper && responseMapper.getStatusMsg() !== null && responseMapper.getStatusMsg() !== undefined)
        {
            message = responseMapper.getStatusMsg();
        }
        this.getAPIFailure(new RewardPointResponseDtoImpl(APIFeatures.GET_REWARD_POINT, message));   
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/rewardpointapiprocessor.tsx